import { render } from "./StatBlock.vue?vue&type=template&id=6a474c80&scoped=true"
import script from "./StatBlock.vue?vue&type=script&lang=js"
export * from "./StatBlock.vue?vue&type=script&lang=js"

import "./StatBlock.vue?vue&type=style&index=0&id=6a474c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a474c80"]])

export default __exports__